import { ref, shallowRef, watch } from 'vue'
import {
  documentAgreementFileCreate,
  documentAgreementFiles,
} from '@/requests/documentAgreement'
import { DocumentAgreementFile } from '@/utils/types/documentAgreement'
import { File } from '@/utils/types/helpers'
import { DocumentAgreementContext } from '../types'

export function useFiles(context: DocumentAgreementContext) {
  const { documentAgreementId, documentAgreementSource, setDocumentAgreement } =
    context

  const files = shallowRef<DocumentAgreementFile[]>([])
  const currentFile = ref<DocumentAgreementFile>(null)

  const getFiles = () => {
    return documentAgreementFiles(documentAgreementId.value).then(res => {
      files.value = res
    })
  }

  const createFileVersion = (newFile: File[]) => {
    return documentAgreementFileCreate({
      documentId: documentAgreementId.value,
      name: newFile[0].name,
      path: newFile[0].path,
      size: newFile[0].size,
    }).then(res => {
      files.value = [...files.value, res]
      setDocumentAgreement({ file: res })
    })
  }

  watch(
    () => documentAgreementSource.file,
    file => {
      if (file && !currentFile.value) {
        currentFile.value = file
      }
    },
    { immediate: true }
  )

  return { files, currentFile, getFiles, createFileVersion }
}
